import { jsx as _jsx } from "preact/jsx-runtime";
import clsx from 'clsx';
import styles from './Button.module.scss';
const Button = ({ id, dataTestId, className, secondary, isSmall, backgroundColor, textColor, hoverColor, onClick, children, }) => {
    const style = {
        '--button-bg-color': backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : '#088488',
        '--button-text-color': textColor !== null && textColor !== void 0 ? textColor : '#fff',
        '--button-hover-color': hoverColor !== null && hoverColor !== void 0 ? hoverColor : '#005252',
    };
    const classNames = clsx(styles.button, className, {
        [styles.secondary]: secondary,
        [styles.smallButton]: isSmall,
    });
    return (_jsx("button", Object.assign({ id: id, "data-testid": dataTestId, className: classNames, style: style, onClick: onClick }, { children: children }), void 0));
};
export default Button;
